import { useNavigate, useParams } from '@tanstack/react-router';
import { ARPaymentDetailSlidein } from '@/components/accounts-receivable/payment-detail/ar-payment-detail-slidein';

export function ARPaymentDetailRoute() {
  const { arPaymentId } = useParams({
    from: '/authenticated/accounts-receivable/payments/$arPaymentId',
  });
  const navigate = useNavigate();

  return (
    <ARPaymentDetailSlidein
      paymentId={arPaymentId}
      isOpen
      onOpenChange={() => {
        navigate({ to: '..', search: true, viewTransition: true });
      }}
    />
  );
}
